import { QuoteStatus, RequestStatus, RequireOnly } from '@pelicargo/types';
import { FreightService, PaymentStatus, Request, ShipmentStatus } from '@prisma/client';

import {
  NEXT_EMAIL_DRAWERS,
  NEXT_PAYMENT_STATUSES,
  NEXT_QUOTE_STATUSES,
  NEXT_REQUEST_STATUSES,
  NEXT_SHIPMENT_STATUSES_AFR,
  NEXT_SHIPMENT_STATUSES_EXW,
  NEXT_SHIPMENT_STATUSES_FCA,
} from './constants';

export const getNextRequestStatus = (currentStatus: RequestStatus) => {
  return NEXT_REQUEST_STATUSES[currentStatus];
};

export const getNextShipmentStatus = (
  currentStatus: ShipmentStatus,
  request: RequireOnly<Request, 'freight_services'>,
) => {
  if (request.freight_services?.includes(FreightService.EXW)) {
    return NEXT_SHIPMENT_STATUSES_EXW[currentStatus] ?? ShipmentStatus.PENDING;
  } else if (request.freight_services?.includes(FreightService.FCA)) {
    return NEXT_SHIPMENT_STATUSES_FCA[currentStatus] ?? ShipmentStatus.PENDING;
  } else {
    return NEXT_SHIPMENT_STATUSES_AFR[currentStatus] ?? ShipmentStatus.PENDING;
  }
};

export const getNextPaymentStatus = (currentStatus: keyof typeof NEXT_PAYMENT_STATUSES) => {
  return NEXT_PAYMENT_STATUSES[currentStatus] ?? PaymentStatus.PENDING;
};

export const getNextQuoteStatus = (currentStatus: QuoteStatus) => {
  return NEXT_QUOTE_STATUSES[currentStatus];
};

export const getNextEmailDrawerType = (currentStatus: RequestStatus) => {
  return NEXT_EMAIL_DRAWERS[currentStatus];
};
